import { render, staticRenderFns } from "./foot-path.vue?vue&type=template&id=edd1faac&scoped=true&"
import script from "./foot-path.vue?vue&type=script&lang=js&"
export * from "./foot-path.vue?vue&type=script&lang=js&"
import style0 from "./foot-path.vue?vue&type=style&index=0&id=edd1faac&lang=scss&scoped=true&"
import style1 from "./foot-path.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd1faac",
  null
  
)

export default component.exports